import React from 'react';
import Const from 'fw_const';
// -------------------------------------------------------

export default {
  /*
   * 進捗ステータスの取得
   */
  getProgressStatus(progress, groups, is_ng){
    let name = '';
    let main_progress = progress;
    groups.map((d) => {
      if( d.id == progress ) name = d.name;
      if( d.id == progress && d.parent != undefined ) main_progress = d.parent;
    });
    
    let result = {};
    Const.value.workflow.map((d) => {
      if( d.id == main_progress ) result = Object.assign({}, d);
    });
    
    // カードのカラー設定
    if( is_ng == 1 ){
      result = { id: 'ng', name: 'アサインNG', color: 'red', image: 'ng' };
      name = 'アサインNG';
    }
    
    result.rename = name;
    return result;
  },
  // -------------------------------------------------------
  
  /*
   * アクション情報の取得
   */
  getRequestAction(base, insta_user_id, mode){
    let action = null;
    try {
      
      let influencer = base.workflow.influencers[insta_user_id];
      if( influencer == undefined || Object.keys(influencer).length == 0 ) return null;
      
      let status = influencer.status;
      
      // クライアントチェック
      if( influencer.progress == 'client_check' ){
        if( status.is_client_check !== 1 ) action = 'client_check';
      }
      
      // クライアントチェック
      if( influencer.progress == 'client_re_check' ){
        if( status.is_client_check_complete === 1 ) action = 'client_re_check';
      }
      
      // アサインアクション
      if( influencer.progress == 'assign_action' ){
        if( status.is_assign !== 1 ) action = 'assign_action';
      }
      
      // 下書き提出
      if( influencer.progress == 'draft' && status.is_entry == 1 ){
        if( status.is_draft !== 1 ) action = 'draft_action';
      }
      
      // 下書き確認
      if( influencer.progress == 'draft' ){
        base.check_draft.map((d) => { if( d.insta_user_id == influencer.insta_user_id && d.is_submission == 1 ) action = 'draft_check'; });
      }
      
      // 投稿選択
      //if( influencer.progress == 'waiting_post' && influencer.report_setting == 0 ){
      if( action == null && influencer.status.is_draft_complete == 1 ){
        if( influencer.post_contents == undefined || influencer.reports == undefined || influencer.reports.length < influencer.post_contents.length ){
          action = 'report_select';
        }
      }
      
      // タスク外の情報も取得
      if( mode == 'full_task' && action == null ){
        
        if( status.is_client_check === 1 && status.is_client_check_complete !== 1 ) action = 'client_check_cancel';
        
        if( status.is_assign === 1 && status.is_entry == null ) action = 'assign_action_cancel';
        
        if( status.is_draft === 1 && status.is_draft_complete == 0 ) action = 'draft_action_cancel';
        
      }
    } catch(e) {};
    
    return action;
  },
  // -------------------------------------------------------
  
  /*
   * 進捗ステータスの取得
   */
  getProgressMark(influencer){
    if( influencer == undefined ) return null;
    
    let st = influencer.action_status;
    
    if( st == 'is-assign-ng' ) return <p className="is-assign-ng">NG</p>;
    if( st == 'is-client-check' ) return <p className="is-client-check">チェック中</p>;
    if( st == 'is-assign' ) return <p className="is-assign">依頼中</p>;
    if( st == 'is-draft' ) return <p className="is-draft">下書き中</p>;
    
    return null;
  },
  // -------------------------------------------------------
  
  /*
   * レポート投稿設定が必要なアカウント
   */
  getReportSelectTarget(base, insta_user_id){
    
    let post_count = 0;
    try { post_count = base.workflow.influencers[insta_user_id].post_contents.length; } catch(e) {}
    
    let report_count = 0;
    base.report.list.map((d) => { if( d.insta_user_id == insta_user_id ) report_count += 1; });
    
    let is_draft_complete = 0;
    try { is_draft_complete = base.workflow.influencers[insta_user_id].status.is_draft_complete; } catch(e) {}
    
    if( post_count > 0 && (post_count > report_count) && is_draft_complete == 1 ) return true;
    
    return false;
  },
  // -------------------------------------------------------
  
}